import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { StoreKeys, useStore } from '../../shared/store';
import { CogIcon, EyeIcon, PencilIcon, TrashIcon } from '@heroicons/react/outline';
import { classNames, noop } from '../../utils';
import { Button } from '../button';
import { useDrawer } from '../../shared/drawer';
import { AddTree } from '../../../assets/icons/AddTree';
import { useHttpClient } from '../../shared/http-client';
import { useModal } from '../../shared/modals';
import { PaginationComponent } from '../../shared/pagination';
import { renderTableItem } from '../table-item/table-item.element';
import { PaginationFilterComponent } from '../../shared/pagination-filter';


export const TableFilter = ({
    Form,
    FormAdd,
    path,
    storePath,
    deletePath = noop(),
    deletePath2 = false,
    query = '',
    onShow,
    onSelection,
    headers,
    parent = {},
    buttonLabel,
    setCount = noop,
    parentData,
    isParentData,
    limit = 10,
    resultados = true,
    noAction = false,
    isVehicle = false,
    withPagination = false,
    withSelection = false,
    doSelection = noop,
    callBeforeDrawerClosed = noop,
    compressed = false,
    size = 'xl',
    onDelete = noop,
    noDelete = false,
    isOnDelete = false,
    doEdit = noop(),
    noEdit = false,
    refresh,
    specialVersion = false,
    page: pageProp,
    onPageChange,
}: any) => {
    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const { get, set } = useStore();
    const [hover, setHover] = useState<number | null>(null);
    const [data, setData] = useState<any | null>(null);
    const [selection, setSelection] = useState<any[]>([]);
    const [masterSelection, setMasterSelection] = useState<boolean>(false);
    const { open: openModal, close: closeModal } = useModal();
    const { open: openDrawer, close: closeDrawer } = useDrawer();

    const [internalPage, setInternalPage] = useState<number>(0);
    const page = typeof pageProp === 'number' ? pageProp : internalPage; // page is always a number
    const setPage = onPageChange || setInternalPage;
    const [counterTotal, setCounterTotal] = useState<number | null>(0);
    const [counter, setCounter] = useState<number | null>(0);
    const [maxRecords, setMaxRecords] = useState<number>(0);
    const [refreshPagination, setRefreshPagination] = useState<string | null>(null);

    // Corrige la página si está fuera de rango tras filtrar
    useEffect(() => {
        const totalPages = Math.ceil(maxRecords / limit);
        if (page > 0 && page >= totalPages) {
            setPage(0);
        }
    }, [maxRecords, page, limit]);

    // Llama a request() cuando cambian page, limit o paginador
    useEffect(() => {
        if (withPagination) {
            request();
        }
    }, [page, limit, withPagination, refreshPagination]);

    // Sincroniza el estado data con la respuesta de la API
    useEffect(() => {
        if (state.data) {
            setData(state.data.results ?? state.data);
        }
    }, [state.data]);

    const request = () => {

        if (path && !specialVersion) {
            let endpoint = `${path}${query ? '?' : ''}${query}${withPagination
                ? `${query ? '&' : '?'}limit=${limit}&offset=${(page ?? 0) * limit}`
                : ''
                }`;

            Object.keys(parent).forEach((key: string) => {
                const regex = new RegExp(`:${key}`, 'g');

                endpoint = endpoint.replace(regex, parent[key]);
            });


            api(endpoint, 'GET');
        }
        if (path && specialVersion) {
            let endpoint = `${path}${query}${withPagination
                ? `${query ? '&' : '?'}limit=${limit}&offset=${(page ?? 0) * limit}`
                : ''
                }`;


            Object.keys(parent).forEach((key: string) => {
                const regex = new RegExp(`:${key}`, 'g');

                endpoint = endpoint.replace(regex, parent[key]);
            });

            // console.log("TABLE ENDPOINT :: ", endpoint);

            api(endpoint, 'GET');
        }
    };

    const handleClose = () => {
        request();
        callBeforeDrawerClosed();

        setTimeout(() => {
            closeDrawer();
        }, 200);
    };



    const handleEditAction = (item: any) => {
        set(`${storePath}-limit`, limit);
        set(`${storePath}-offset`, page);
        if (doEdit) {
            doEdit(item);
        } else {
            openDrawer(
                'common.form-title.edit-item',
                <Form item={item} close={handleClose} />,
                true,
                size
            );
        }
    };

    const handleNewOperationAction = () => {
        if (FormAdd) {
            openDrawer(
                'common.form-title.new-item',
                <FormAdd close={handleClose} />
            );
        } else {
            openDrawer(
                'common.form-title.new-item',
                <Form close={handleClose} />
            );
        }
    };

    const handleDelete = (item: any) => {
        if (deletePath2) {
            if (item?.identification_document_type) {
                openModal('error', {
                    title: 'common.modal.delete',
                    message: 'common.modal.validate-delete',
                    onAccept: () => {
                        api(`/identification_documents/${item.id}/`, 'DELETE');

                        setData([
                            ...data.filter(
                                (element: { id: number }) => element.id !== item.id
                            )
                        ]);

                        setCount(data.length - 1);
                        setPage(0);
                        setRefreshPagination(Date.now().toString());
                        setTimeout(() => {
                            closeModal();
                            setRefreshPagination(null);
                            onDelete(null)
                            //callBeforeDrawerClosed();
                        }, 500);
                    }
                });

            } else if (item?.vehicle_document_type) {

                openModal('error', {
                    title: 'common.modal.delete',
                    message: 'common.modal.validate-delete',
                    onAccept: () => {
                        api(`/vehicle_documents/${item.id}/`, 'DELETE');

                        setData([
                            ...data.filter(
                                (element: { id: number }) => element.id !== item.id
                            )
                        ]);

                        setCount(data.length - 1);
                        setPage(0);
                        setRefreshPagination(Date.now().toString());
                        setTimeout(() => {
                            closeModal();
                            setRefreshPagination(null);
                            onDelete(null)
                            //callBeforeDrawerClosed();
                        }, 500);
                    }
                });

            }

        } else {
            openModal('error', {
                title: 'common.modal.delete',
                message: 'common.modal.validate-delete',
                onAccept: () => {
                    api(`${deletePath ? deletePath : path}${item.id}/`, 'DELETE');

                    setData([
                        ...data.filter(
                            (element: { id: number }) => element.id !== item.id
                        )
                    ]);

                    setCount(data.length - 1);
                    setPage(0);
                    setRefreshPagination(Date.now().toString());
                    setTimeout(() => {
                        closeModal();
                        setRefreshPagination(null);
                        onDelete(null)
                        callBeforeDrawerClosed();
                    }, 500);
                }
            });
        }

    };



    const handelMasterCheck = (e: any) => {
        let tempList = [...data];
        tempList.map((item) => (item.selected = e.target.checked));

        setSelection(data.filter((e: any) => e.selected));
        setMasterSelection(e.target.checked);
        setData(tempList)

        doSelection(tempList.filter((e) => e.selected));
    }

    const handleItemCheck = (e: any, row: any) => {
        let tempList = data;
        tempList.map((item: any) => {
            if (item.id === row.id) {
                item.selected = e.target.checked;
            }
            return item;
        });

        // To Control Master Checkbox State
        const totalItems = data.length;
        const totalCheckedItems = tempList.filter((e: any) => e.selected).length;

        setSelection(data.filter((e: any) => e.selected));
        setMasterSelection(totalItems === totalCheckedItems);
        setData(tempList)

        doSelection(tempList.filter((e: any) => e.selected));
    }

    useEffect(() => {
        if (parentData && Object.keys(parentData).length > 0) {
            setData([...parentData]);
        }
    }, [parentData]);

    useEffect(() => {
        if (storePath) {
            const initialPage = get(`${storePath}-offset`) || 0;
            set(`${storePath}-offset`, initialPage);
        } else {
            setPage(0);
        }
    }, []);

    useEffect(() => {

        if (!isParentData && query !== null) {

            if (page !== null) {
                //set(`${storePath}-offset`, page);
            }
            request();
        } else if (parentData) {
            setData([...parentData]);
        }
    }, [page, query, refresh]);



    const addSelection = (data: any) => {
        if (withSelection) {
            let tempData = [...data];
            tempData.forEach((item: any) => {
                item.checked = false;
            });
            setData(tempData);
        } else {
            setData(data);
        }
    }

    useEffect(() => {

        if (state.method === 'DELETE') {
            if (state.path.includes('vehicle_registers')) {
                if (deletePath && deletePath === '/vehicle_registers/') {
                    callBeforeDrawerClosed();
                }
            }
            if (state.path.includes('companies')) {
                if (state?.error) {
                    toast.error(`${t('common.error.delete-empresa')}`);
                    callBeforeDrawerClosed();
                }
            }
            if (state.path.includes('providers')) {
                if (state?.error) {
                    toast.error(`${t('common.error.delete-proveedor')}`);
                    callBeforeDrawerClosed();
                }
            }
        }
        if (state.data && state.data.results) {
            addSelection(state.data.results);
            setData(state.data.results);
            setCount(state.data.results.length);
            setMaxRecords(state.data.count);
            setCounter(state.data.results.length);
            setCounterTotal(state.data.count);


            if (state.path.includes('vehicle_registers/?id=')) {
                if (state.method === 'GET') {
                    if (state?.data?.results[0]?.owner?.id) {
                        setData([state?.data?.results[0]]);
                    } else {
                        setData(null);
                        setCounterTotal(0);
                    }

                }

            }
        }

        if (state.error) {
            if (state.path.includes('manipulators')) {
                if (state.method === 'DELETE') {
                    if (state.error.error == 'Cannot delete due to protected foreign key references.') {
                        toast.error(`${t('common.label.error.delete-manipulador')}`);
                        callBeforeDrawerClosed();
                    }
                }
            } else if (state.error.error == 'Cannot delete due to protected foreign key references.') {
                {
                    toast.error(`${t('common.error.delete-key')}`);
                    callBeforeDrawerClosed();
                }
            }

            if (state.error.detail == 'You cannot delete yourself.') {
                toast.error(`${t('common.error.delete-yourself')}`);
                callBeforeDrawerClosed();
            }
            if (state.path.includes('vehicle_registers')) {
                if (state.method === 'DELETE') {
                    if (state.error.error.includes('Cannot delete a vehicle register')) {
                        toast.error(`${t('common.label.error.delete-vehicle-register')}`);
                        callBeforeDrawerClosed();
                    }
                    if (state.error.error.includes('Cannot delete the last vehicle register')) {
                        toast.error(`${t('common.label.error.delete-vehicle-register2')}`);
                        callBeforeDrawerClosed();
                    }

                }
            }

            if (state.method === 'DELETE') {
                if (state.error.error === 'This record cannot be deleted because it is referenced by other records.') {
                    toast.error(`${t('common.error.no-delete')}`);
                    callBeforeDrawerClosed();
                }

            }


        }
    }, [state]);



    return (
        <div className="flex flex-col mb-3 w-full">
            {/*   <div className='pb-2 text-sm font-bold'>{t('common.label.resultados')}<span className='font-normal'>{counter}</span></div> */}
            {resultados ? <div className='pb-4 text-sm font-bold flex justify-end pr-4'>{t('common.label.resultados')} <span className='font-normal'>{counterTotal}</span></div> : ''}

            {state.isLoading
                ?
                <div className={"w-full flex justify-center items-center py-4"}>
                    <CogIcon className={"h-4 w-4 text-gray-400 animate-spin"} />
                </div>
                : null
            }

            <div className="">
                <table className="w-full max-w-full">
                    <thead className='rounded-t-md'>
                        <tr className="bg-[#006bc6]">
                            {withSelection
                                ? <th scope="col">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={masterSelection}
                                        id="mastercheck"
                                        onChange={(e) => handelMasterCheck(e)}
                                    />
                                </th>
                                : null}
                            {headers.map((header: any, index: number) => (
                                <th
                                    key={index}
                                    scope="col"
                                    style={{ width: header.width || 'auto' }}
                                    className="py-3.5 pl-4 pr-3 text-left bg-transparent text-white sm:pl-6 not-italic text-xs leading-6 first:rounded-tl-lg"
                                >
                                    {t(header.label)}
                                </th>
                            ))}

                            {!noAction && (
                                <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 rounded-tr-lg"
                                >
                                    {' '}
                                </th>
                            )}
                        </tr>
                    </thead>
                    {data?.length ? (
                        <tbody className="divide-y divide-gray-200 bg-white">
                            {/*render totals*/}
                            {/* <tr>
                                {headers.map((header: any, index: number) => (
                                    <td
                                        key={index}
                                        className={
                                            'py-3.5 pl-4 pr-3 text-left font-bold text-xl'
                                        }
                                    >
                                        {header.totalTitle
                                            ? t(header['totalTitle'])
                                            : header.total
                                                ? header['type'] === 'decimal'
                                                    ? (
                                                        header.totalValue ||
                                                        data.reduce(
                                                            (
                                                                acc: number,
                                                                item: any
                                                            ) =>
                                                                acc +
                                                                item[header.key],
                                                            0
                                                        )
                                                    ).toFixed(2) +
                                                    ' ' +
                                                    header['totalSuffix']
                                                    : header['type'] === 'currency'
                                                        ? (
                                                            header.totalValue ||
                                                            data.reduce(
                                                                (
                                                                    acc: number,
                                                                    item: any
                                                                ) =>
                                                                    acc +
                                                                    item[header.key],
                                                                0
                                                            )
                                                        )
                                                            .toFixed(2)
                                                            .replace(
                                                                /\d(?=(\d{3})+\.)/g,
                                                                '$&,'
                                                            ) +
                                                        ` ${(header as any)
                                                            ?.totalSuffix || '€'
                                                        }`
                                                        : (header.totalValue ||
                                                            data.reduce(
                                                                (
                                                                    acc: number,
                                                                    item: any
                                                                ) =>
                                                                    acc +
                                                                    item[header.key],
                                                                0
                                                            )) +
                                                        ' ' +
                                                        header['totalSuffix']
                                                : ''}
                                    </td>
                                ))}
                            </tr> */}
                            {/*render totals*/}

                            {data.map((item: any, index: any) => (
                                <tr
                                    key={index}
                                    onMouseEnter={() => setHover(index)}
                                    onMouseLeave={() => setHover(null)}
                                    className="hover:bg-gray-200 text-base hover:font-semibold transition-all duration-200"
                                >
                                    {withSelection
                                        ? <th scope="col">
                                            <input
                                                type="checkbox"
                                                checked={item.selected}
                                                className="form-check-input"
                                                id="rowcheck{user.id}"
                                                onChange={(e) => handleItemCheck(e, item)}
                                            />
                                        </th>
                                        : null}

                                    {renderTableItem(
                                        item,
                                        headers,
                                        'py-3.5 pl-4 pr-3 text-left text-gray-900 sm:pl-6'
                                    )}

                                    {!noAction && (
                                        <td
                                            className={classNames(
                                                compressed ? 'py-1' : 'py-4',
                                                'relative whitespace-nowrap pl-3 pr-4 text-right text-sm font-medium sm:pr-6 z-10'
                                            )}
                                        >
                                            {
                                                <>
                                                    {onShow && (
                                                        <button
                                                            className="p-2 rounded-md"
                                                            onClick={
                                                                hover === index
                                                                    ? () =>
                                                                        onShow(
                                                                            item
                                                                        )
                                                                    : noop
                                                            }
                                                        >
                                                            <EyeIcon
                                                                className={classNames(
                                                                    'h-5 w-5 ',
                                                                    hover ==
                                                                        index
                                                                        ? 'text-primary hover:text-gray-darker'
                                                                        : 'text-primary'
                                                                )}
                                                            />
                                                        </button>
                                                    )}
                                                    {onSelection && (isVehicle ? item?.available : true) ? (
                                                        <button
                                                            className="p-2 rounded-md"
                                                            onClick={
                                                                hover === index
                                                                    ? () =>
                                                                        onSelection(
                                                                            item
                                                                        )
                                                                    : noop
                                                            }
                                                        >
                                                            <div className='text-gray-400'>{t('common.label.select')}</div>
                                                        </button>
                                                    ) : ''}
                                                    {!noEdit ? <button
                                                        className="p-2 rounded-md"
                                                        onClick={
                                                            hover === index
                                                                ? () =>
                                                                    handleEditAction(
                                                                        item
                                                                    )
                                                                : noop
                                                        }
                                                    >
                                                        <PencilIcon
                                                            className={classNames(
                                                                'h-5 w-5 ',
                                                                hover == index
                                                                    ? 'text-primary hover:text-gray-darker'
                                                                    : 'text-primary'
                                                            )}
                                                        />
                                                    </button> : ''}
                                                    {!noDelete ? <button
                                                        className="p-2 rounded-md"
                                                        onClick={
                                                            hover === index
                                                                ? () =>
                                                                    handleDelete(
                                                                        item
                                                                    )
                                                                : noop
                                                        }
                                                    >
                                                        <TrashIcon
                                                            className={classNames(
                                                                'h-5 w-5 ',
                                                                hover == index
                                                                    ? 'text-gray-dark hover:text-gray-darker'
                                                                    : 'text-gray-dark'
                                                            )}
                                                        />
                                                    </button> : ''}
                                                    {isOnDelete ? <button
                                                        className="p-2 rounded-md"
                                                        onClick={
                                                            hover === index
                                                                ? () =>
                                                                    onDelete(
                                                                        item
                                                                    )
                                                                : noop
                                                        }
                                                    >
                                                        <TrashIcon
                                                            className={classNames(
                                                                'h-5 w-5 ',
                                                                hover == index
                                                                    ? 'text-gray-dark hover:text-gray-darker'
                                                                    : 'text-gray-dark'
                                                            )}
                                                        />
                                                    </button> : ''}
                                                </>
                                            }
                                        </td>
                                    )}
                                </tr>
                            ))}

                        </tbody>

                    ) : (
                        <tbody className="bg-white">
                            <tr>
                                <td
                                    colSpan={headers.length + 1}
                                    className="text-center pt-4"
                                >
                                    <span className="not-italic font-light text-sm leading-6 text-gray-darker">
                                        {t('common.message.no-data')}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    )}
                    <tfoot className=''>
                        <tr className=''>
                            <td colSpan={headers.length + 1} className="bg-white rounded-b-lg p-4 shadow-md">
                                <div className="text-sm text-gray-700 text-center">
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

                {withPagination && (
                    <PaginationFilterComponent
                        doPage={(page: number) => setPage(page)}
                        page={page}
                        limit={limit}
                        maxRecords={maxRecords}
                        reset={refreshPagination}
                    />
                )}

                {buttonLabel && (
                    <div className="mt-[8px]">
                        <Button
                            variant="gray-light"
                            icon={<AddTree />}
                            disabled={!parent?.id}
                            label={t(buttonLabel)}
                            onClick={handleNewOperationAction}
                        />
                    </div>
                )}
                {/*</div>*/}
            </div>
        </div>
    )
        ;
};
